"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE_MAP = exports.SIZE_TO_INTERNAL_SIZE = exports.SPINNER_COLOR_MAP = exports.COLOR_MAP = exports.VARIATNT_TO_INTERNAL_VARIANT = void 0;
var style_1 = require("../../../style");
var variables_1 = require("../../../style/variables");
exports.VARIATNT_TO_INTERNAL_VARIANT = {
    primary: 'primary',
    secondary: 'secondary',
    dark: 'dark',
    flush: 'tertiary',
};
exports.COLOR_MAP = {
    primary: {
        default: {
            border: style_1.SixsenseColor.Blue.DEFAULT,
            background: style_1.SixsenseColor.Blue.DEFAULT,
            font: 'white',
        },
        focused: {
            border: style_1.SixsenseColor.Blue.LIGHT_1,
            background: style_1.SixsenseColor.Blue.LIGHT_1,
            font: 'white',
        },
        disabled: {
            border: style_1.SixsenseColor.Gray.LIGHT_4,
            background: style_1.SixsenseColor.Gray.LIGHT_5,
            font: style_1.SixsenseColor.Gray.LIGHT_3,
        },
    },
    dark: {
        default: {
            border: style_1.SixsenseColor.Gray.DARK_3,
            background: style_1.SixsenseColor.Gray.DARK_3,
            font: 'white',
        },
        focused: {
            border: style_1.SixsenseColor.Gray.DARK_2,
            background: style_1.SixsenseColor.Gray.DARK_2,
            font: 'white',
        },
        disabled: {
            border: style_1.SixsenseColor.Gray.LIGHT_4,
            background: style_1.SixsenseColor.Gray.LIGHT_5,
            font: style_1.SixsenseColor.Gray.LIGHT_2,
        },
    },
    secondary: {
        default: {
            border: style_1.SixsenseColor.Gray.LIGHT_2,
            background: 'white',
            font: style_1.SixsenseColor.Gray.DARK_2,
            spinner: style_1.SixsenseColor.Blue.DEFAULT,
        },
        focused: {
            border: style_1.SixsenseColor.Blue.DEFAULT,
            background: 'white',
            font: style_1.SixsenseColor.Blue.DEFAULT,
            spinner: style_1.SixsenseColor.Blue.DEFAULT,
        },
        disabled: {
            border: style_1.SixsenseColor.Gray.LIGHT_4,
            background: 'white',
            font: style_1.SixsenseColor.Gray.LIGHT_3,
        },
    },
    flush: {
        default: {
            border: 'transparent',
            background: 'transparent',
            font: style_1.SixsenseColor.Gray.DARK_2,
        },
        focused: {
            border: style_1.SixsenseColor.Gray.LIGHT_5,
            background: style_1.SixsenseColor.Gray.LIGHT_5,
            font: style_1.SixsenseColor.Gray.DARK_5,
        },
        disabled: {
            border: 'transparent',
            background: 'transparent',
            font: style_1.SixsenseColor.Gray.LIGHT_3,
        },
    },
};
exports.SPINNER_COLOR_MAP = {
    secondary: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
    tertiary: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
};
exports.SIZE_TO_INTERNAL_SIZE = {
    sm: 'small',
    small: 'small',
    md: 'default',
    default: 'default',
    lg: 'large',
    large: 'large',
};
exports.SIZE_MAP = {
    small: {
        font: '12px',
        padding: '0 12px',
        height: '28px',
        spinner: 12,
    },
    default: {
        font: '14px',
        padding: '0 15px',
        height: '36px',
        spinner: 16,
    },
    large: {
        font: '14px',
        padding: '0 18px',
        height: '42px',
        spinner: 20,
    },
};
